import React, { useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Icon from '@mui/material/Icon';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme as useMuiTheme, alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

import PackagePaymentTab from './tabs/PackagePaymentTab';
import OtherPaymentTab from './tabs/OtherPaymentTab';
import { SessionPaymentTab } from './tabs/SessionPaymentTab';

export default function TakePaymentModal({ open, onClose, tokens }) {
  const theme = useMuiTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [tab, setTab] = useState(0);

  const title = useMemo(() => {
    if (tab === 0) return 'Paket Ödemesi';
    if (tab === 1) return 'Seans Ödemesi';
    return 'Diğer Ödeme';
  }, [tab]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '22px',
          overflow: 'hidden',
          background: tokens?.isDark ? alpha('#0b1220', 0.92) : alpha('#ffffff', 0.98),
          border: `1px solid ${tokens?.border || theme.palette.divider}`,
          boxShadow: fullScreen
            ? 'none'
            : '0 22px 60px rgba(0,0,0,.16), 0 10px 22px rgba(0,0,0,.12)',
          backgroundImage: 'none',
        },
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: fullScreen ? 'rgba(0,0,0,.55)' : 'rgba(0,0,0,.45)',
          backdropFilter: 'blur(6px)',
        },
      }}
    >
      <DialogTitle sx={{ pb: 1.1 }}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
          <MDBox display="flex" alignItems="center" gap={1.2} sx={{ minWidth: 0 }}>
            <MDBox
              sx={{
                width: 42,
                height: 42,
                borderRadius: '16px',
                display: 'grid',
                placeItems: 'center',
                background: alpha(theme.palette.success.main, 0.12),
                border: `1px solid ${alpha(theme.palette.success.main, 0.22)}`,
                flex: '0 0 auto',
              }}
            >
              <Icon sx={{ fontSize: 20, color: theme.palette.success.main }}>payments</Icon>
            </MDBox>

            <MDBox sx={{ minWidth: 0 }}>
              <MDTypography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
                Ödeme Al
              </MDTypography>
              <MDTypography variant="caption" sx={{ opacity: 0.78, display: 'block', mt: 0.35 }}>
                {title}
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDButton
            variant="text"
            color="secondary"
            onClick={onClose}
            sx={{ minWidth: 44, width: 44, height: 44, borderRadius: '14px' }}
          >
            <Icon>close</Icon>
          </MDButton>
        </MDBox>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 1.2, pb: 1.2 }}>
        <MDBox sx={{ ...tokens?.card, p: 1.0, borderRadius: '18px' }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="fullWidth"
            sx={{
              mb: 1,
              minHeight: 38,
              '& .MuiTab-root': { minHeight: 38, fontWeight: 900, textTransform: 'none' },
            }}
          >
            <Tab label="Paket" />
            <Tab label="Seans" />
            <Tab label="Diğer" />
          </Tabs>

          {tab === 0 ? <PackagePaymentTab /> : null}
          {tab === 1 ? <SessionPaymentTab /> : null}
          {tab === 2 ? <OtherPaymentTab /> : null}
        </MDBox>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2, pt: 1.4 }}>
        <MDButton
          variant="outlined"
          color="dark"
          onClick={onClose}
          fullWidth={fullScreen}
          sx={{ borderRadius: '16px', textTransform: 'none', fontWeight: 900, height: 44 }}
        >
          Kapat
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
